import { render, staticRenderFns } from "./SetProjectThumbnail.vue?vue&type=template&id=5a49cf71&scoped=true"
import script from "./SetProjectThumbnail.vue?vue&type=script&lang=js"
export * from "./SetProjectThumbnail.vue?vue&type=script&lang=js"
import style0 from "./SetProjectThumbnail.vue?vue&type=style&index=0&id=5a49cf71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49cf71",
  null
  
)

export default component.exports